import React from 'react';
import moment from 'moment';

// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  CardBody,
  InputGroup,
  Input,
  Modal,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavLink,
  Badge,
} from 'reactstrap';
import classnames from 'classnames';
// core components
import Header from 'components/Headers/Header.js';
import { axiosGet, axiosPost } from 'util/apiConfig.js';
import Select from "react-select";
import { value } from "lodash/seq";
import "./SalesNotification.css";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { Device } from '@twilio/voice-sdk';
import { CopyToClipboard } from "react-copy-to-clipboard";

const USER_STATE = {
  CONNECTING: "Connecting",
  READY: "Ready",
  ON_CALL: "On call",
  OFFLINE: "Offline",
}

const WHATSAPP_TEMPLATES = [
  {
    title: 'Greeting & Class Sign-up',
    body: (name) => `Hi ${name || 'there'}, this is the Fiverkids Sales Team. We saw you signed up for a trial class! We'd love to connect and help you set everything up. Please let us know if you have a few minutes to talk today.`
  },
  {
    title: 'Missed Class Follow-up',
    body: (name) => `Hi ${name || 'there'}, we noticed you missed your trial class. No worries at all! You can easily reschedule to a better time using this link: {rescheduleUrl} - hope to see you in class soon!`
  },
  {
    title: 'Post-Trial Feedback',
    body: (name) => `Hi ${name || 'there'}, hope your child enjoyed their Fiverkids Python session! Let us know if you'd like to explore our membership plans to continue their coding journey.`
  },
  {
    title: 'Reschedule Assistance',
    body: (name) => `Hi ${name || 'there'}, this is Fiverkids support. We would be happy to assist in finding a better time slot for your child's coding trial. Please reply with your preferred day and time!`
  },
  {
    title: 'Custom Message',
    body: () => ''
  }
];

const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#fff',
    border: state.isFocused ? '1px solid #5e72e4' : '1px solid #e9ecef',
    borderRadius: '8px',
    boxShadow: state.isFocused ? '0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)' : 'none',
    cursor: 'pointer',
    minHeight: '43px',
    transition: 'all 0.15s ease',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 12px',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#adb5bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#525f7f',
    fontSize: '14px',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#5e72e4' : state.isFocused ? '#f6f9fc' : '#fff',
    color: state.isSelected ? '#fff' : state.isFocused ? '#5e72e4' : '#525f7f',
    cursor: 'pointer',
    fontSize: '14px',
    padding: '10px 12px',
  }),
  menu: (provided) => ({
    ...provided,
    border: '1px solid #e9ecef',
    borderRadius: '8px',
    boxShadow: '0 50px 100px rgba(50,50,93,.1),0 15px 35px rgba(50,50,93,.15),0 5px 15px rgba(0,0,0,.1)',
    zIndex: 9999,
  }),
};


class SalesFollowUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      listPage: 1,
      listPageSale: 1,
      totalListPageSale: '',
      rowLimitSale: 10,
      rowLimit: 10,


      modalTitle: '',
      successModal: false,
      errorModal: false,
      message: '',
      editModal: false,
      editSalesModal: false,
      classList: [],
      notificationNotesModal: false,
      notificationCallModal: false,
      salesFollowUpModal: false,
      salesFollowUpClassScriptModal: false,
      addModal: false,
      filterTeacher: null,

      notificationStatus: '',
      device: undefined,
      userState: USER_STATE.OFFLINE,
      allFollowUpStatus: [],
      salesFollowUpInfo: [],
      messageStates: {},
      activeCard: "followUp",
      followUpScript: '',
      salesFollowUpNotes: '',
      selectedClassId: '',
      selectedSalesId: '',
      selectedRecipientName: '',
      messageChannel: 'sms', // 'sms' or 'whatsapp'
      whatsappHistory: [],
      loadingWhatsappHistory: false,
      showWhatsappHistory: false,
      directWhatsappModal: false,
      directWhatsappName: '',
      directWhatsappNumber: '',
      directWhatsappCountryCode: '+91',
      directWhatsappMessage: '',
      directWhatsappTemplateIndex: 0,
      directWhatsappClassId: '',
      directWhatsappSalesId: '',
      startClass: false,
      selectedSalesNotification: null,
    };
  }

  componentDidMount() {
    let storage = localStorage.getItem('Sanga_Admin');
    storage = storage ? JSON.parse(storage) : null;
    const classId = localStorage.getItem("classId");
    this.setState(
      {
        globalClassId: classId ? classId : null,
        userId: storage && storage.userId,
        userName: storage && storage.name,
        userType: storage && storage.userType,
        newRequestList: [],
        allMessages: [],
        allCounts: [],
        allSalesUser: [],
      },
      () => {
        this.getClass();
        // this.callInit();
        this.getNotificationAllMessage();
        this.getSalesNotification();
        this.setState({
          allNotificationStatus: [
            {
              value: 'Default',
              label: 'Default',
            }, {
              value: 'Very Interested',
              label: 'Very Interested',
            }, {
              value: 'Medium Interested',
              label: 'Medium Interested',
            }, {
              value: 'Less Interested',
              label: 'Less Interested',
            }, {
              value: 'Teacher No Show',
              label: 'Teacher No Show',
            }, {
              value: 'Student No Show',
              label: 'Student No Show',
            }, {
              value: 'Cancel Class',
              label: 'Cancel Class',
            },
          ], allFollowUpStatus: [
            {
              value: 'Default',
              label: 'Default',
            }, {
              value: 'No Response - 1st Try',
              label: 'No Response - 1st Try',
            }, {
              value: 'No Response - 2nd Try',
              label: 'No Response - 2nd Try',
            }, {
              value: 'No Response - 3rd Try',
              label: 'No Response - 3rd Try',
            }, {
              value: 'Will Sign up',
              label: 'Will Sign up',
            }, {
              value: 'Enrolled',
              label: 'Enrolled',
            }, {
              value: 'Connect in few months',
              label: 'Connect in few months',
            }, {
              value: 'Not Interested',
              label: 'Not Interested',
            }, {
              value: 'Not Contacted',
              label: 'Not Contacted',
            },
          ]
        });
      }
    );
  }

  getClass = () => {
    // API --
    axiosGet(`class/get-classes-list`)
      .then((response) => {
        if (!response.isError) {
          this.getNotificationMessage(response.data[0].classId);
          this.setState({
            classList: response.data || [],
            classId: response.data[0].classId,
          });
        } else {
          this.setState({
            classList: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          classList: [],
        });
      });
  };

  getNotificationMessage = (classId) => {
    axiosGet(`sales/get-notification-message/${classId}`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            followUpScript: response.data[0].followUpScript,
            messageId: response.data[0]?.messageId,
          });
        }
      })
      .catch((error) => {
        this.setState({
          followUpScript: '',
          messageId: '',
        });
      });
  };

  getNotificationAllMessage = () => {
    axiosGet(`sales/get-notification-message/`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            salesFollowUpScript: response.data || [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          salesFollowUpScript: [],
        });
      });
  };

  // to get all messages -
  getSalesNotification = (search) => {
    const { listPage, rowLimit, globalClassId, activeCard, searchNotification } = this.state;
    let url = `sales/get-all-sales-notification/${listPage}/${rowLimit}`;
    const queryParams = [];
    if (globalClassId) {
      queryParams.push(`classId=${globalClassId}`);
    }
    queryParams.push(`notificationStatus=Very Interested`);
    queryParams.push(`status=${activeCard}`);
    if (searchNotification) {
      queryParams.push(`name=${searchNotification}`);
    }
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }
    axiosGet(`${url}`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            allMessages: response.data?.result,
            totalNewPage: response.data?.noofpage,
          });
        } else {
          this.setState({
            allMessages: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          allMessages: [],
        });
        console.log(error);
      });
  };



  changePage = (status) => {
    if (status && status === 'next') {
      this.setState({ listPage: this.state.listPage + 1 }, () =>
        this.getSalesNotification()
      );
    } else if (status && status === 'prev') {
      this.setState({ listPage: this.state.listPage - 1 }, () =>
        this.getSalesNotification()
      );
    }
  };


  clientConnect = (index) => {
    let { allMessages } = this.state;
    let selectedNotification = allMessages[index];
    this.setState({
      notificationCallModal: true,
      selectedNumber: selectedNotification.mobile || '',
      selectedClassId: selectedNotification.classId || '',
      selectedSalesId: selectedNotification.notificationId || '',
      selectedRecipientName: selectedNotification.name || '',
      messageChannel: 'sms',
      whatsappHistory: [],
      showWhatsappHistory: false,
    });
  };

  fetchWhatsappHistory = () => {
    const { selectedNumber } = this.state;
    if (!selectedNumber) return;
    this.setState({ loadingWhatsappHistory: true });
    const fullNumber = selectedNumber.startsWith('+') ? selectedNumber : `+1${selectedNumber}`;
    axiosGet(`message/whatsapp/history/${fullNumber}`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            whatsappHistory: response.data || [],
            loadingWhatsappHistory: false,
            showWhatsappHistory: true
          });
        } else {
          this.setState({ loadingWhatsappHistory: false });
          alert('Failed to load WhatsApp history.');
        }
      })
      .catch((error) => {
        this.setState({ loadingWhatsappHistory: false });
        console.error('Error fetching WhatsApp history:', error);
        alert('Error loading WhatsApp history.');
      });
  };

  openDirectWhatsapp = (index) => {
    const { allMessages } = this.state;
    const selectedNotification = allMessages[index];
    if (!selectedNotification) return;

    let rawNumber = selectedNotification.mobile || '';
    // Robust cleanup of twilio prefix if present
    rawNumber = rawNumber.replace(/^whatsapp:/i, '').trim();

    let countryCode = '+91'; // default prefix
    let numberOnly = rawNumber;

    if (rawNumber.startsWith('+')) {
      // Find matching country code from our supported list
      const supportedCodes = ['+91', '+1', '+44', '+61', '+65', '+971', '+64', '+33', '+49', '+81', '+82', '+60', '+62', '+852'];
      let foundCode = supportedCodes.find(code => rawNumber.startsWith(code));
      if (foundCode) {
        countryCode = foundCode;
        numberOnly = rawNumber.substring(foundCode.length);
      } else {
        const match = rawNumber.match(/^\+(\d{1,4})/);
        if (match) {
          countryCode = `+${match[1]}`;
          numberOnly = rawNumber.substring(match[0].length);
        }
      }
    } else {
      let digits = rawNumber.replace(/\D/g, '');
      if (digits.length === 10) {
        numberOnly = digits;
      } else if (digits.length > 10) {
        if (digits.startsWith('91') && digits.length === 12) {
          countryCode = '+91';
          numberOnly = digits.substring(2);
        } else if (digits.startsWith('1') && digits.length === 11) {
          countryCode = '+1';
          numberOnly = digits.substring(1);
        } else {
          numberOnly = digits;
        }
      } else {
        numberOnly = digits;
      }
    }

    // Strip out all non-digits from numberOnly for presentation
    numberOnly = numberOnly.replace(/\D/g, '');

    const defaultMsg = `Hi ${selectedNotification.name || 'there'}, this is the Fiverkids Sales Team. We saw you signed up for a trial class! We'd love to connect and help you set everything up. Please let us know if you have a few minutes to talk today.`;

    this.setState({
      directWhatsappModal: true,
      selectedSalesNotification: selectedNotification,
      directWhatsappName: selectedNotification.name || '',
      directWhatsappNumber: numberOnly,
      directWhatsappCountryCode: countryCode,
      directWhatsappMessage: defaultMsg,
      directWhatsappTemplateIndex: 0,
      directWhatsappClassId: selectedNotification.classId || '',
      directWhatsappSalesId: selectedNotification.notificationId || '',
    });
  };

  handleTemplateChange = (templateIdx) => {
    const { selectedSalesNotification } = this.state;
    const name = selectedSalesNotification ? selectedSalesNotification.name : '';
    const rescheduleUrl = selectedSalesNotification ? (selectedSalesNotification.rescheduleUrl || '') : '';

    let text = WHATSAPP_TEMPLATES[templateIdx].body(name);
    if (rescheduleUrl) {
      text = text.replace(/{rescheduleUrl}/g, rescheduleUrl);
    } else {
      text = text.replace(/{rescheduleUrl}/g, 'our booking page');
    }

    this.setState({
      directWhatsappTemplateIndex: templateIdx,
      directWhatsappMessage: text
    });
  };

  sendDirectWhatsapp = () => {
    const { directWhatsappMessage, directWhatsappNumber, directWhatsappCountryCode, directWhatsappClassId, directWhatsappSalesId, directWhatsappName } = this.state;

    if (!directWhatsappMessage || !directWhatsappMessage.trim()) {
      return alert('Please enter a message to send.');
    }
    if (!directWhatsappNumber || !directWhatsappNumber.trim()) {
      return alert('Please enter a phone number.');
    }

    const cleanNumber = directWhatsappNumber.replace(/\D/g, '');
    const fullNumber = `whatsapp:${directWhatsappCountryCode}${cleanNumber}`;

    const confirmSend = window.confirm(
      `Do you want to send this WhatsApp message to ${directWhatsappName || 'Customer'} (${directWhatsappCountryCode}${cleanNumber})?\n\n` +
      `Message: "${directWhatsappMessage}"`
    );

    if (confirmSend) {
      this.setState({ loading: true });
      const dataToSend = {
        to: fullNumber,
        message: directWhatsappMessage,
        classId: directWhatsappClassId,
        salesId: directWhatsappSalesId,
        recipientName: directWhatsappName
      };

      axiosPost('message/whatsapp/send', dataToSend)
        .then((response) => {
          if (!response.isError) {
            this.setState({
              directWhatsappModal: false,
              directWhatsappMessage: '',
              loading: false
            });
            alert('WhatsApp message sent successfully!');
          } else {
            this.setState({ loading: false });
            alert('Failed to send WhatsApp message: ' + response.message);
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          console.error('Error sending direct WhatsApp:', error);
          alert('Error sending WhatsApp message.');
        });
    }
  };

  salesFollowUpScript = () => {
    this.setState({
      salesFollowUpClassScriptModal: true,
    });
  };

  addNotes = (index) => {
    let { allMessages, salesFollowUpScript } = this.state;
    let selectedNotification = allMessages[index];
    const followUpScript = salesFollowUpScript.find((sales) => sales.classId == selectedNotification.classId);
    this.setState({
      notificationNotesModal: true,
      selectedNotification,
      followUpNotes: selectedNotification.notes || '',
      followUpScript: followUpScript.followUpScript || '',
      salesFollowUpNotes: selectedNotification.salesFollowUpNotes || ''
    });
  };

  startClass = (index) => {
    let { allMessages } = this.state;
    let selectedNotification = allMessages[index];
    this.setState({ startClass: true, selectedNotification }, () => {
      this.callStartEvent(selectedNotification);
    });
  };

  callStartEvent = () => {
    let { selectedNotification, startClass } = this.state;
    let dataToSend = {
      notificationId: selectedNotification.notificationId,
      startClass
    }
    axiosPost(`sales/start-class-update`, dataToSend)
      .then((response) => {
        if (!response.isError) {
          const notification = this.state.allMessages.find((item) => item.notificationId === selectedNotification.notificationId);
          notification.startClass = true;
          this.setState(
            {
              successModal: true,
              modalTitle: 'Success',
              message: 'Class started successfully After 40 min it will be automatically End Class',
            }
          );
        } else {
          this.setState(
            {
              errorModal: true,
              modalTitle: 'Sorry!',
              message: response.message,
            }
          );
        }
      })
      .catch((error) => {
        this.setState({
          errorModal: true,
          modalTitle: 'Error',
          message: 'An error occurred while starting the class.',
        });
      });
  };

  followupInfo = (index) => {
    let { allMessages } = this.state;
    let selectedNotification = allMessages[index];
    this.setState({
      salesFollowUpModal: true,
      salesFollowUpInfo: selectedNotification?.salesFollowUp || ''
    });
  };

  addBookMark = (flag, index) => {
    try {
      let { allMessages } = this.state;
      let selectedNotification = allMessages[index];
      let dataToSend = {
        notificationId: selectedNotification.notificationId,
        starBookMark: flag
      };
      this.setState({ loading: true });
      axiosPost('sales/update-notification-status', dataToSend)
        .then((response) => {
          if (!response.isError) {
            this.setState(
              {
                loading: false,
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully Updated.',
              },
              () => {
                this.getSalesNotification();
              }
            );
          } else {
            this.setState({
              loading: false,
              errorModal: true,
              modalTitle: 'Sorry!',
              message: 'Something is wrong. Try again later.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
          console.log(error);
        });
    } catch (e) {
      console.log("Error:", e)
    }
  };
  callInit = (sale, index) => {
    axiosPost('sales/token', {})
      .then((response) => {
        if (!response.isError) {
          this.setState(
            {
              loading: false
            },
            () => {
              const token = response.data.token;
              const device = new Device(token, {
                logLevel: 1,
                codecPreferences: ["opus", "pcmu"],
              });
              device.register();
              this.setState({ device })
              device.addListener("connect", (device) => {
                console.log("Connect event listener added .....");
                return device;
              });
              device.on("registered", () => {
                console.log("Agent registered");
                this.setState({ userState: USER_STATE.READY });
              });
              device.on("connect", (connection) => {
                console.log("Call connect");
                this.setState({ userState: USER_STATE.ON_CALL })
              });
              device.on("disconnect", () => {
                console.log("Disconnect event");
                this.setState({ userState: USER_STATE.READY })
              });

              setTimeout(() => {
                this.handleCall(sale, index)
              }, 1000)
              return () => {
                device.destroy();
                this.setState({ device: undefined })
                this.setState({ userState: USER_STATE.OFFLINE })
              };
            }
          );
        } else {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorModal: true,
          modalTitle: 'Sorry!',
          message: 'Something is wrong. Try again later.',
        });
        console.log(error);
      });
  }

  handleCall = async (sale, index) => {
    const className = this.state.classList.find((item) => item.classId === sale.classId).name;
    const confirm = window.confirm(`Are you sure want to call? \nPlease verify details\nClass name: ${className || ''},\nMobile: ${sale.mobile}, `)
    if (!confirm) {
      return false;
    }
    const { device, userType } = this.state;
    device.emit("connect");
    const mobileToCall = sale.mobile && !sale.mobile.startsWith('+') ? `+1${sale.mobile}` : sale.mobile;
    device.connect({ params: { To: mobileToCall, notificationId: sale.notificationId, userType, classId: sale.classId } }).then((call) => {
      call.on("accept", () => {
        this.updateMessageState(index, USER_STATE.ON_CALL);
        console.log("call accepted");
      });
      call.on("disconnect", () => {
        console.log("The call has been disconnected.");
        this.updateMessageState(index, USER_STATE.READY);
      });
      call.on("reject", () => {
        console.log("The call was rejected.");
      });
      call.on("cancel", () => {
        console.log("The call was rejected.");
        this.updateMessageState(index, USER_STATE.READY);
      });
    })
  };


  updateMessageState = (index, newState) => {
    this.setState(prevState => ({
      messageStates: {
        ...prevState.messageStates,
        [index]: newState
      }
    }));
  };


  rejectCall = () => {
    const { device, selectedNumber } = this.state
    device.emit("disconnect");
    device.emit("cancel");
    device.emit("reject");
    device.disconnectAll({ params: { To: selectedNumber } });
  }


  replyMessageResponse = () => {
    let { twillioMessage, loading, selectedNumber, selectedClassId } = this.state;
    if (!twillioMessage || twillioMessage.trim() === '') {
      return alert('Please enter message');
    }

    let confirm = window.confirm('Are you sure want send message?');

    if (confirm) {
      if (twillioMessage && !loading) {
        this.setState({ loading: true });
        const fullNumber = selectedNumber.startsWith('+') ? selectedNumber : `+1${selectedNumber}`;
        let dataToSend = {
          message: twillioMessage,
          to: fullNumber,
          classId: selectedClassId
        };

        const endpoint = 'message/send-reply';
        // API -
        axiosPost(endpoint, dataToSend)
          .then((response) => {
            if (!response.isError) {
              this.setState(
                {
                  loading: false,
                  notificationCallModal: false,
                  twillioMessage: '',
                  selectedNumber: '',
                },
                () => {
                }
              );
            } else {
              this.setState({
                loading: false,
                modalTitle: 'Sorry!',
                message: 'Something is wrong. Try again later.',
                notificationCallModal: false,
                twillioMessage: '',
                selectedNumber: '',
              });
            }
          })
          .catch((error) => {
            this.setState({
              loading: false,
              errorModal: true,
              message: 'Something is wrong. Try again later.',
              notificationCallModal: false,
              twillioMessage: '',
              selectedNumber: '',
            });
          });
      }
    }
  };


  handleNotificationStatusChange = (e, index) => {
    let message = "Are you sure you want to change the status?"
    let confirm = window.confirm(message);
    if (confirm) {
      let { allMessages } = this.state;
      let selectedNotification = allMessages[index];
      let dataToSend = {
        notificationId: selectedNotification.notificationId,
        followUpStatus: e.value
      };
      this.setState({ loading: true });
      axiosPost('sales/update-notification-status', dataToSend)
        .then((response) => {
          if (!response.isError) {
            this.setState(
              {
                loading: false,
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully Updated.',
              },
              () => {
                this.getSalesNotification();
              }
            );
          } else {
            this.setState({
              loading: false,
              errorModal: true,
              modalTitle: 'Sorry!',
              message: 'Something is wrong. Try again later.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
          console.log(error);
        });
    }
  };

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
      modalTitle: '',
      message: '',
    });
    if (state === 'notificationModal' || state === 'editModal') {
      this.resetForm();
    } else if (state === 'notificationModal') {
      this.setState({
        email: '',
        name: '',
        mobile: '',
      });
    }
  };

  isTimeInRange(timezone) {
    const now = new Date();
    const userTime = new Intl.DateTimeFormat('en-US', { hour: 'numeric', hour12: false, timeZone: timezone }).format(now);
    const hour = parseInt(userTime, 10);

    // Check if the time is between 8 AM (8) and 9 PM (21)
    return hour >= 8 && hour < 21;
  }

  resetForm = () => {
    this.setState({
      loading: false,
      followUpScript: '',
      followUpNotes: '',
      salesFollowUpNotes: '',
    });
  };

  updateNotificationNotes = () => {
    let {
      followUpScript,
      followUpNotes,
      salesFollowUpNotes,
      selectedNotification
    } = this.state;
    let dataToSend = {
      followUpScript,
      followUpNotes,
      salesFollowUpNotes,
      notificationId: selectedNotification.notificationId
    };
    axiosPost(`sales/update-notification-notes`, dataToSend)
      .then((response) => {
        this.setState({
          notificationNotesModal: false,
          loading: false,
        });
        if (!response.isError) {
          this.setState(
            {
              successModal: true,
              modalTitle: 'Success',
              message: 'Successfully saved.',
            },
            () => {
              this.resetForm();
              this.componentDidMount()
            }
          );
        } else {
          this.setState(
            {
              errorModal: true,
              modalTitle: 'Sorry!',
              message: response.message,
            },
            () => {
              this.resetForm();
            }
          );
        }
      })
      .catch((errorResponse) => {
        this.setState(
          {
            notificationNotesModal: false,
            errorModal: true,
            loading: false,
            modalTitle: 'Sorry!',
            message: errorResponse.message,
          },
          () => {
            this.resetForm();
          }
        );
      });

  };

  updateNotificatioScript = () => {
    let {
      followUpScript,
      classId,
      messageId
    } = this.state;
    let dataToSend = {
      followUpScript,
      classId,
      messageId
    };
    axiosPost(`sales/update-notification-message-script`, dataToSend)
      .then((response) => {
        this.setState({
          salesFollowUpClassScriptModal: false,
          loading: false,
        });
        if (!response.isError) {
          this.setState(
            {
              successModal: true,
              modalTitle: 'Success',
              message: 'Successfully saved.',
            },
            () => {
              this.resetForm();
              this.componentDidMount()
            }
          );
        } else {
          this.setState(
            {
              errorModal: true,
              modalTitle: 'Sorry!',
              message: response.message,
            },
            () => {
              this.resetForm();
            }
          );
        }
      })
      .catch((errorResponse) => {
        this.setState(
          {
            salesFollowUpClassScriptModal: false,
            errorModal: true,
            loading: false,
            modalTitle: 'Sorry!',
            message: errorResponse.message,
          },
          () => {
            this.resetForm();
          }
        );
      });

  };

  searchNotification = (e) => {
    let val = e.target.value;
    this.setState({ searchNotification: val }, () =>
      this.getSalesNotification()
    );
  };

  changeClassMessage = (classId) => {
    this.getNotificationMessage(classId)
  }

  editNotification = (index) => {
    let { allMessages } = this.state;
    let selectedNotification = allMessages[index];
    this.setState({
      editModal: true,
      name: selectedNotification.name,
      email: selectedNotification.email,
      mobile: selectedNotification.mobile,
      classId: selectedNotification.classId,
      createdBy: selectedNotification.createdBy,
      zoomLinkSales: selectedNotification.zoomLink,
      selectedNotification
    });
  };

  addOrUpdateNotification = (isCalledForEditNotification) => {
    let {
      name,
      mobile,
      selectedNotification,
    } = this.state;
    !name
      ? this.setState({ nameError: true })
      : this.setState({ nameError: false });
    !mobile
      ? this.setState({ mobileError: true })
      : this.setState({ mobileError: false });
    if (name && mobile) {
      let dataToSend = {
        name,
        mobile,
      };
      if (isCalledForEditNotification) {
        dataToSend = { ...dataToSend, ...{ notificationId: selectedNotification.notificationId } };
      }
      const endPointUrl = isCalledForEditNotification
        ? 'sales/edit-notification'
        : 'sales/add-notification';
      axiosPost(`${endPointUrl}`, dataToSend)
        .then((response) => {
          this.setState({
            editModal: false,
            selectedChapter: '',
            notificationModal: false,
            loading: false,
          });
          if (!response.isError) {
            this.setState(
              {
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully saved.',
              },
              () => {
                this.resetForm();
                this.componentDidMount()
              }
            );
          } else {
            this.setState(
              {
                errorModal: true,
                modalTitle: 'Sorry!',
                message: response.message,
              },
              () => {
                this.resetForm();
              }
            );
          }
        })
        .catch((errorResponse) => {
          this.setState(
            {
              editModal: false,
              selectedChapter: '',
              notificationModal: false,
              errorModal: true,
              loading: false,
              modalTitle: 'Sorry!',
              message: errorResponse.message,
            },
            () => {
              this.resetForm();
            }
          );
        });
    }
  };


  render() {
    let {
      loading,
      allMessages,
      listPage,
      totalNewPage,
      notificationCallModal,
      salesFollowUpModal,
      modalTitle,
      notesError,
      message,
      successModal,
      errorModal,
      allNotificationStatus,
      activeCard,
      twillioMessage,
      allFollowUpStatus,
      salesFollowUpInfo,
      notificationNotesModal,
      salesFollowUpClassScriptModal,
      followUpScript,
      followUpNotes,
      salesFollowUpNotes,
      uploading,
      classList,
      userType,
      classId,
      classIdError,
      editModal,
      nameError,
      mobileError,
      email,
      name,
      mobile,
      messageChannel,
      whatsappHistory,
      loadingWhatsappHistory,
      showWhatsappHistory,
    } = this.state;
    return (
      <>
        <Header />
        {/* Page content */}
        <Container fluid>
          {/* Table */}
          <Row>
            <div className='col'>
              <Card className='shadow border-0' style={{ borderRadius: '15px', overflow: 'hidden' }}>
                <CardHeader className="bg-transparent border-0 d-flex flex-column flex-sm-row justify-content-between align-items-sm-center py-4" style={{ gap: '15px' }}>
                  <h3 className="mb-0 text-primary font-weight-700" style={{ fontSize: '20px' }}>Follow Up</h3>
                  {userType === 'admin' && (
                    <Button
                      color="primary"
                      type="button"
                      className="shadow-sm font-weight-600 px-4 py-2"
                      style={{ borderRadius: '8px', fontSize: '13px' }}
                      onClick={() => this.salesFollowUpScript()}
                    >
                      <i className="fa fa-file-alt mr-2" /> Followup Script
                    </Button>
                  )}
                </CardHeader>

                <CardBody className="pt-0">
                  <Row className="mb-4">
                    <Col className="d-flex justify-content-center justify-content-sm-start">
                      <Nav pills className="nav-fill flex-row w-100" style={{ backgroundColor: '#f1f3f9', borderRadius: '12px', boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)', maxWidth: '480px', padding: '4px' }}>
                        <NavItem style={{ width: '33.33%' }}>
                          <NavLink
                            className={classnames("py-2 text-center font-weight-700", { active: activeCard === "followUp" })}
                            onClick={() => {
                              this.setState({ activeCard: "followUp", page: 1 }, () => {
                                this.getSalesNotification();
                              });
                            }}
                            style={{ border: 'none', borderRadius: '9px', cursor: "pointer", fontSize: '12.5px', transition: 'all 0.2s ease' }}
                          >
                            <i className="fa fa-reply mr-1" /> Follow Up
                          </NavLink>
                        </NavItem>
                        <NavItem style={{ width: '33.33%' }}>
                          <NavLink
                            className={classnames("py-2 text-center font-weight-700", { active: activeCard === "Not Interested" })}
                            onClick={() => {
                              this.setState({ activeCard: "Not Interested", page: 1 }, () => {
                                this.getSalesNotification();
                              });
                            }}
                            style={{ border: 'none', borderRadius: '9px', cursor: "pointer", fontSize: '12.5px', transition: 'all 0.2s ease' }}
                          >
                            <i className="fa fa-times-circle mr-1" /> Not Interested
                          </NavLink>
                        </NavItem>
                        <NavItem style={{ width: '33.33%' }}>
                          <NavLink
                            className={classnames("py-2 text-center font-weight-700", { active: activeCard === "Connect in few months" })}
                            onClick={() => {
                              this.setState({ activeCard: "Connect in few months", page: 1 }, () => {
                                this.getSalesNotification();
                              });
                            }}
                            style={{ border: 'none', borderRadius: '9px', cursor: "pointer", fontSize: '12.5px', transition: 'all 0.2s ease' }}
                          >
                            <i className="fa fa-calendar-alt mr-1" /> Connect In Few Months
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Col>
                  </Row>

                  <Row className="align-items-end">
                    <Col xs="12" sm="8" md="6" lg="4">
                      <FormGroup className="mb-0">
                        <label className="form-control-label text-muted" style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '0.5px' }}>SEARCH</label>
                        <div className="d-flex align-items-center" style={{ backgroundColor: '#fff', border: '1px solid #e9ecef', borderRadius: '8px', height: '43px', padding: '0 12px', transition: 'all 0.15s ease' }}>
                          <i className="fa fa-search text-muted mr-2" style={{ fontSize: '13px' }} />
                          <input
                            placeholder="Search by Name, Email or Mobile Number"
                            type="text"
                            name="search"
                            className="w-100"
                            style={{ backgroundColor: 'transparent', border: 'none', color: '#525f7f', fontSize: '14px', outline: 'none' }}
                            onChange={this.searchNotification}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>


                <Table
                  className='align-items-center table-flush cp; d-none d-lg-table'
                  responsive
                  style={{ marginBottom: '100px' }}
                >
                  <thead className='thead-light'>
                    <tr>
                      <th scope='col' style={{ width: '60px' }}>Actions</th>
                      <th scope='col' style={{ width: '220px' }}>Dial & Log Hub</th>
                      <th scope='col'>Follow Up</th>
                      <th scope='col'>Student Details</th>
                      <th scope='col'>Class name</th>
                      <th scope='col'>Start Time</th>
                      <th scope='col'>Time Zone</th>
                      <th scope='col'>Created By</th>
                      <th scope='col'>Age</th>
                      <th scope='col'>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allMessages &&
                      allMessages.map((value, index) => {
                        const isActiveTime = this.isTimeInRange(value?.timezone || 'Asia/kolkata');
                        const [isRegistration] = value?.sections && value?.sections.map((section) => {
                          if (section.classId == value.classId) {
                            return true
                          }
                        })
                        const isActive = Object.values(this.state.messageStates).some(
                          state => state === 'Connecting' || state === 'On call'
                        )
                        const className = classList?.find((item) => item?.classId === value?.classId)?.name;
                        const startClass = className === '1:1 Python Class' ? { backgroundColor: '#f9f6ff' } : {};
                        const userStateForMessage = this.state.messageStates[index] || USER_STATE.OFFLINE;

                        let firstCellStyle = {};
                        if (className === '1:1 Python Class') {
                          firstCellStyle = { borderLeft: '5px solid #8965e0' };
                        }

                        return (
                          value.isActive && (
                            <tr key={index} style={startClass}>
                              <td className={'table-column-width'} style={{ ...firstCellStyle, verticalAlign: 'middle', width: '60px' }}>
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    className='btn-icon-only text-light'
                                    href='JavaScript:Void(0);'
                                    role='button'
                                    size='sm'
                                    color=''
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    <i className='fas fa-ellipsis-v' />
                                  </DropdownToggle>
                                  <DropdownMenu
                                    className='dropdown-menu-arrow'
                                    right
                                  >
                                    <DropdownItem
                                      href='JavaScript:Void(0);'
                                      onClick={() => this.editNotification(index)}
                                    >
                                      Edit
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </td>
                              <td className={'table-column-width'} style={{ verticalAlign: 'middle', width: '220px' }}>
                                <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                                  {
                                    value.starBookMark ? (
                                      <Button
                                        color="secondary"
                                        size="sm"
                                        className="btn-icon-only rounded-circle shadow-sm"
                                        onClick={() => this.addBookMark(false, index)}
                                        style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                      >
                                        <i className="fa fa-star" style={{ color: 'green', fontSize: '12px' }} />
                                      </Button>
                                    ) : (
                                      <Button
                                        color="secondary"
                                        size="sm"
                                        className="btn-icon-only rounded-circle shadow-sm"
                                        onClick={() => this.addBookMark(true, index)}
                                        style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                      >
                                        <i className="fa fa-star text-muted" style={{ fontSize: '12px' }} />
                                      </Button>
                                    )
                                  }


                                  {
                                    value.salesFollowUp && value.salesFollowUp.length > 0 && (
                                      <Button
                                        color="secondary"
                                        size="sm"
                                        className="btn-icon-only rounded-circle shadow-sm"
                                        onClick={() => this.followupInfo(index)}
                                        style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                      >
                                        <i className="fa fa-info text-info" style={{ fontSize: '12px' }} />
                                      </Button>
                                    )
                                  }

                                  {
                                    (userStateForMessage === 'Connecting' || userStateForMessage === 'On call') ? (
                                      <Button
                                        color="danger"
                                        size="sm"
                                        className="btn-icon-only rounded-circle"
                                        onClick={() => this.rejectCall(value.mobile)}
                                      >
                                        <i className="fa fa-phone" style={{ fontSize: '12px' }} />
                                      </Button>
                                    ) : (
                                      isActiveTime ? (
                                        <Button
                                          color="secondary"
                                          size="sm"
                                          className="btn-icon-only rounded-circle shadow-sm"
                                          disabled={isActive}
                                          onClick={() => this.callInit(value, index)}
                                          style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                        >
                                          <i className="fa fa-phone text-success" style={{ fontSize: '12px' }} />
                                        </Button>
                                      ) : null
                                    )
                                  }
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    className="btn-icon-only rounded-circle shadow-sm"
                                    onClick={() => this.clientConnect(index)}
                                    style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                  >
                                    <i className="fa fa-comments text-primary" style={{ fontSize: '12px' }} />
                                  </Button>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    className="btn-icon-only rounded-circle shadow-sm"
                                    onClick={() => this.openDirectWhatsapp(index)}
                                    style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                  >
                                    <i className="fab fa-whatsapp text-success" style={{ fontSize: '13px', fontWeight: 'bold' }} />
                                  </Button>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    className="btn-icon-only rounded-circle shadow-sm"
                                    onClick={() => this.addNotes(index)}
                                    style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                  >
                                    <i className="fa fa-book text-default" style={{ fontSize: '12px' }} />
                                  </Button>
                                </div>
                              </td>
                              <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                <div>
                                  <Select
                                    options={allFollowUpStatus}
                                    placeholder="Select Follow-up Status"
                                    isSearchable={true}
                                    menuPosition={'fixed'}
                                    menuPlacement={'bottom'}
                                    styles={{
                                      control: styles => ({ ...styles, borderRadius: '8px', width: 200 }),
                                      menu: styles => ({ ...styles, borderRadius: '8px', width: 200 }),
                                    }}
                                    onChange={(e) => this.handleNotificationStatusChange(e, index)}
                                    value={allFollowUpStatus.find(option => option.value == value.followUpStatus)}
                                  />
                                </div>
                              </td>
                              <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                <div className="d-flex flex-column" style={{ gap: '2px' }}>
                                  <div className="d-flex align-items-center">
                                    {isRegistration && (
                                      <span style={{ backgroundColor: '#11cdef', borderRadius: '50%', display: 'inline-block', height: '8px', marginRight: '6px', width: '8px' }} />
                                    )}
                                    <span className="font-weight-700 text-dark" style={{ fontSize: '13.5px' }}>{value.name}</span>
                                  </div>
                                  <a href={`mailto:${value.email}`} className="text-muted" style={{ fontSize: '11.5px', textDecoration: 'none' }}>
                                    <i className="fa fa-envelope mr-1 text-muted" style={{ fontSize: '10px' }} />
                                    {value.email}
                                  </a>
                                  {value.mobile && (
                                    <a href={"tel:" + value.mobile} className="text-muted font-weight-600" style={{ fontSize: '11.5px', textDecoration: 'none' }}>
                                      <i className="fa fa-phone mr-1 text-muted" style={{ fontSize: '10px' }} />
                                      {value.mobile}
                                    </a>
                                  )}
                                </div>
                              </td>
                              <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>{className || ''}</td>
                              <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                <Media className='align-items-center'>
                                  <Media className="d-flex flex-column" style={{ width: '100%' }}>
                                    <span className='mb-0 text-sm font-weight-600 text-muted' style={{ fontSize: '12.5px' }}>
                                      {value.startTime
                                        ? moment(value.startTime).format('ll hh:mm A')
                                        : ''}
                                    </span>
                                    <div className="mt-1">
                                      <Button color="primary" size="sm" style={{ borderRadius: '8px', fontWeight: '700' }} onClick={() => this.startClass(index)}>Start Session</Button>
                                    </div>
                                    {value.started_at && value.started_at.length > 0 ? (
                                      <div className="mt-1" style={{ width: '100%' }}>
                                        <span className="badge badge-dot d-flex align-items-center">
                                          <i className="bg-success" style={{ height: '6px', width: '6px' }} />
                                          <span className="status font-weight-700 text-success" style={{ fontSize: '9px', marginLeft: '4px' }}>
                                            Started ({value.started_at.length}x)
                                          </span>
                                        </span>
                                        <div
                                          className="shadow-sm mt-1"
                                          style={{
                                            backgroundColor: '#f8f9fa',
                                            border: '1px solid rgba(0,0,0,.03)',
                                            borderRadius: '4px',
                                            fontSize: '9.5px',
                                            lineHeight: '1.3',
                                            maxHeight: '60px',
                                            overflowY: 'auto',
                                            padding: '4px 6px',
                                          }}
                                        >
                                          {value.started_at.map((start, idx) => (
                                            <div key={idx} className="text-muted">
                                              {moment(start.startedAt).format('h:mm A')} -{' '}
                                              <strong className="text-primary">{start.teacherId || 'Teacher'}</strong>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    ) : (
                                      value.startClassTime && (
                                        <span className="badge badge-dot d-flex align-items-center mt-1">
                                          <i className="bg-success" style={{ height: '6px', width: '6px' }} />
                                          <span className="status font-weight-700 text-success" style={{ fontSize: '9px', marginLeft: '4px' }}>
                                            Started: {moment(value.startClassTime).format('hh:mm A')}
                                          </span>
                                        </span>
                                      )
                                    )}
                                  </Media>
                                </Media>
                              </td>
                              <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>{value?.timezone || ''}</td>
                              <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                <Badge color="secondary" className="font-weight-700 text-uppercase" style={{ fontSize: '10.5px' }}>
                                  {value?.createdBy || 'SYSTEM'}
                                </Badge>
                              </td>
                              <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>{value?.age || ''}</td>
                              <td className={'table-column-width'} style={{ verticalAlign: 'middle' }}>
                                <div>
                                  <Select
                                    options={allNotificationStatus}
                                    placeholder="Select Notification Status"
                                    isSearchable={true}
                                    isDisabled={true}
                                    menuPosition={'fixed'}
                                    menuPlacement={'bottom'}
                                    styles={{
                                      control: styles => ({ ...styles, borderRadius: '8px', width: 200 }),
                                      menu: styles => ({ ...styles, borderRadius: '8px', width: 200 }),
                                    }}
                                    value={allNotificationStatus.find(option => option.value == value.notificationStatus)}
                                  />
                                </div>
                              </td>
                            </tr>
                          )
                        );
                      })}
                  </tbody>
                </Table>

                {/* Mobile/Tablet Card-List View */}
                <div className="d-block d-lg-none px-3 py-3" style={{ backgroundColor: '#f8f9fe' }}>
                  {allMessages && allMessages.length > 0 ? (
                    allMessages.map((value, index) => {
                      if (!value.isActive) return null;

                      const isActiveTime = this.isTimeInRange(value?.timezone || 'Asia/kolkata');
                      const [isRegistration] = value?.sections && value?.sections.map((section) => {
                        if (section.classId == value.classId) {
                          return true
                        }
                      })
                      const isActive = Object.values(this.state.messageStates).some(
                        state => state === 'Connecting' || state === 'On call'
                      )
                      const className = classList?.find((item) => item?.classId === value?.classId)?.name;
                      const userStateForMessage = this.state.messageStates[index] || USER_STATE.OFFLINE;

                      let borderLeftStyle = '1px solid #e9ecef';
                      let cardBgStyle = {};
                      if (className === '1:1 Python Class') {
                        cardBgStyle = { backgroundColor: '#f9f6ff' };
                        borderLeftStyle = '6px solid #8965e0';
                      }

                      return (
                        <Card key={index} className="mb-4 border-0" style={{ ...cardBgStyle, borderLeft: borderLeftStyle, borderRadius: '16px', boxShadow: '0 8px 24px rgba(50,50,93,.05),0 1px 3px rgba(0,0,0,.03)', overflow: 'hidden' }}>
                          <CardBody className="p-3">
                            {/* Header: Student Profile & Action Toggle */}
                            <div className="d-flex justify-content-between mb-3">
                              <div style={{ maxWidth: '80%' }}>
                                <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Student Profile</span>
                                <h4 className="font-weight-700 text-dark mb-1 d-inline-flex align-items-center mt-1" style={{ fontSize: '15px' }}>
                                  {isRegistration && (
                                    <span style={{ backgroundColor: '#11cdef', borderRadius: '50%', display: 'inline-block', height: '8px', marginRight: '6px', width: '8px' }} />
                                  )}
                                  {value.name}
                                  {value.age && (
                                    <span className="text-muted font-weight-600 ml-2" style={{ fontSize: '12px' }}>({value.age} yrs)</span>
                                  )}
                                </h4>
                                <div className="d-flex flex-column mt-1" style={{ gap: '4px' }}>
                                  <a href={`mailto:${value.email}`} className="text-primary font-weight-600" style={{ fontSize: '12.5px', textDecoration: 'none' }}>
                                    <i className="fa fa-envelope mr-1 text-muted" style={{ fontSize: '10.5px' }} />
                                    {value.email}
                                  </a>
                                  {value.mobile && (
                                    <a href={`tel:${value.mobile}`} className="text-primary font-weight-600" style={{ fontSize: '12.5px', textDecoration: 'none' }}>
                                      <i className="fa fa-phone mr-1 text-muted" style={{ fontSize: '10.5px' }} />
                                      {value.mobile}
                                    </a>
                                  )}
                                </div>
                              </div>
                              <div className="d-flex flex-column align-items-end" style={{ gap: '6px' }}>
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    className='btn-icon-only text-light mr-n2'
                                    href='JavaScript:Void(0);'
                                    role='button'
                                    size='sm'
                                    color=''
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    <i className='fas fa-ellipsis-v' />
                                  </DropdownToggle>
                                  <DropdownMenu className='dropdown-menu-arrow' right>
                                    <DropdownItem href='JavaScript:Void(0);' onClick={() => this.editNotification(index)}>
                                      Edit
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>

                                {/* Bookmark Star Icon */}
                                <Button
                                  color="secondary"
                                  size="sm"
                                  className="btn-icon-only rounded-circle shadow-sm"
                                  onClick={() => this.addBookMark(!value.starBookMark, index)}
                                  style={{ backgroundColor: '#fff', border: '1px solid #e9ecef' }}
                                >
                                  <i className="fa fa-star" style={{ color: value.starBookMark ? '#2dce89' : '#adb5bd', fontSize: '12px' }} />
                                </Button>
                              </div>
                            </div>

                            {/* Section/Class Box */}
                            <div className="mb-3 p-2.5" style={{ backgroundColor: '#f8f9fe', border: '1px solid #f1f3f9', borderRadius: '10px' }}>
                              <div className="row">
                                <div className="col-7">
                                  <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Class Name</span>
                                  <span className="font-weight-700 text-dark" style={{ fontSize: '13px' }}>{className || 'No Class'}</span>
                                </div>
                                <div className="col-5 text-right">
                                  <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Created By</span>
                                  <span className="badge badge-secondary font-weight-700" style={{ fontSize: '10px' }}>{value?.createdBy?.toUpperCase() || 'SYSTEM'}</span>
                                </div>
                              </div>
                            </div>

                            {/* Timing Details Grid */}
                            <div className="row mb-3" style={{ rowGap: '12px' }}>
                              <div className="col-6">
                                <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Start Time</span>
                                <div style={{ color: '#525f7f', fontSize: '12px', fontWeight: '600' }}>
                                  <i className="fa fa-calendar-alt mr-1 text-muted" style={{ fontSize: '10px' }} />
                                  {value.startTime ? moment(value.startTime).format('ll hh:mm A') : 'N/A'}
                                </div>
                              </div>
                              <div className="col-6">
                                <span className="text-muted font-weight-700 text-uppercase d-block" style={{ fontSize: '9px', letterSpacing: '0.8px' }}>Time Zone</span>
                                <div style={{ color: '#525f7f', fontSize: '12px', fontWeight: '600' }}>
                                  <i className="fa fa-globe mr-1 text-muted" style={{ fontSize: '10px' }} />
                                  {value?.timezone || 'N/A'}
                                </div>
                              </div>
                            </div>

                            {/* Status Selectors Container */}
                            <div className="mb-3 p-2.5" style={{ backgroundColor: '#fcfcfd', border: '1px dashed #e9ecef', borderRadius: '8px' }}>
                              <div className="mb-2">
                                <span className="text-muted font-weight-700 text-uppercase d-block mb-1" style={{ fontSize: '8.5px', letterSpacing: '0.8px' }}>Follow-up Status</span>
                                <Select
                                  options={allFollowUpStatus}
                                  placeholder="Select Follow-up Status"
                                  isSearchable={true}
                                  menuPosition={'fixed'}
                                  menuPlacement={'bottom'}
                                  styles={{
                                    control: styles => ({ ...styles, borderRadius: '8px', width: '100%' }),
                                    menu: styles => ({ ...styles, borderRadius: '8px', width: '100%', zIndex: 9999 }),
                                  }}
                                  onChange={(e) => this.handleNotificationStatusChange(e, index)}
                                  value={allFollowUpStatus.find(option => option.value == value.followUpStatus)}
                                />
                              </div>
                              <div>
                                <span className="text-muted font-weight-700 text-uppercase d-block mb-1" style={{ fontSize: '8.5px', letterSpacing: '0.8px' }}>Notification Status</span>
                                <Select
                                  options={allNotificationStatus}
                                  placeholder="Select Notification Status"
                                  isSearchable={true}
                                  isDisabled={true}
                                  menuPosition={'fixed'}
                                  menuPlacement={'bottom'}
                                  styles={{
                                    control: styles => ({ ...styles, borderRadius: '8px', width: '100%' }),
                                    menu: styles => ({ ...styles, borderRadius: '8px', width: '100%', zIndex: 9999 }),
                                  }}
                                  value={allNotificationStatus.find(option => option.value == value.notificationStatus)}
                                />
                              </div>
                            </div>

                            {/* Dialing & Interaction Hub */}
                            <div className="d-flex flex-wrap align-items-center mb-3" style={{ gap: '8px' }}>
                              {userStateForMessage === 'Connecting' || userStateForMessage === 'On call' ? (
                                <Button
                                  color="danger"
                                  size="sm"
                                  className="px-3 py-2 d-flex align-items-center"
                                  style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                  onClick={() => this.rejectCall(value.mobile)}
                                >
                                  <i className="fa fa-phone-slash mr-1.5" /> Reject Call
                                </Button>
                              ) : (
                                isActiveTime && (
                                  <Button
                                    color="success"
                                    size="sm"
                                    className="px-3 py-2 d-flex align-items-center"
                                    style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                    disabled={isActive}
                                    onClick={() => this.callInit(value, index)}
                                  >
                                    <i className="fa fa-phone mr-1.5" /> Call Client
                                  </Button>
                                )
                              )}

                              <Button
                                color="primary"
                                size="sm"
                                className="px-3 py-2 d-flex align-items-center"
                                style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                onClick={() => this.startClass(index)}
                              >
                                <i className="fa fa-video mr-1.5" /> Start Session
                              </Button>

                              <Button
                                color="info"
                                size="sm"
                                className="px-3 py-2 d-flex align-items-center"
                                style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                onClick={() => this.clientConnect(index)}
                              >
                                <i className="fa fa-comments mr-1.5" /> Chat Logs
                              </Button>

                              <Button
                                color="neutral"
                                size="sm"
                                className="px-3 py-2 d-flex align-items-center text-success border-success"
                                style={{ backgroundColor: '#fff', border: '1px solid', borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                onClick={() => this.openDirectWhatsapp(index)}
                              >
                                <i className="fab fa-whatsapp mr-1.5" /> WhatsApp
                              </Button>

                              <Button
                                color="default"
                                size="sm"
                                className="px-3 py-2 d-flex align-items-center"
                                style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                onClick={() => this.addNotes(index)}
                              >
                                <i className="fa fa-book mr-1.5" /> Notes Log
                              </Button>

                              {value.salesFollowUp && value.salesFollowUp.length > 0 && (
                                <Button
                                  color="warning"
                                  size="sm"
                                  className="px-3 py-2 d-flex align-items-center"
                                  style={{ borderRadius: '8px', fontSize: '11px', fontWeight: '700' }}
                                  onClick={() => this.followupInfo(index)}
                                >
                                  <i className="fa fa-info-circle mr-1.5" /> Follow-up Info
                                </Button>
                              )}
                            </div>

                            {/* Timeline Audit logs container */}
                            {value.started_at && value.started_at.length > 0 ? (
                              <div className="mt-2 pt-2" style={{ borderTop: '1px dashed #e9ecef' }}>
                                <span className="badge badge-dot mr-4">
                                  <i className="bg-success" style={{ height: '8px', width: '8px' }} />
                                  <span className="status font-weight-700 text-success" style={{ fontSize: '11px' }}>
                                    Started ({value.started_at.length}x)
                                  </span>
                                </span>
                                <div
                                  className="shadow-sm mt-1"
                                  style={{
                                    backgroundColor: '#fbfcfd',
                                    border: '1px solid rgba(0,0,0,.05)',
                                    borderRadius: '6px',
                                    maxHeight: '110px',
                                    overflowY: 'auto',
                                    padding: '8px 10px',
                                  }}
                                >
                                  {value.started_at.map((start, i) => (
                                    <div
                                      key={i}
                                      className="d-flex align-items-center mb-1 pb-1"
                                      style={{
                                        borderBottom: i < value.started_at.length - 1 ? '1px dashed #e9ecef' : 'none',
                                        fontSize: '11px',
                                      }}
                                    >
                                      <i className="fa fa-user text-muted mr-1" style={{ fontSize: '10px' }} />
                                      <strong className="text-primary mr-1" style={{ fontSize: '10.5px' }}>
                                        {start.teacherId || 'Teacher'}
                                      </strong>
                                      <span className="text-muted ml-auto">
                                        {moment(start.startedAt).format('h:mm A')}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              value.startClassTime && (
                                <div className="mt-2 pt-2" style={{ borderTop: '1px dashed #e9ecef' }}>
                                  <span className="badge badge-dot d-flex align-items-center">
                                    <i className="bg-success" style={{ height: '6px', width: '6px' }} />
                                    <span className="status font-weight-700 text-success" style={{ fontSize: '9px', marginLeft: '4px' }}>
                                      Started: {moment(value.startClassTime).format('hh:mm A')}
                                    </span>
                                  </span>
                                </div>
                              )
                            )}
                          </CardBody>
                        </Card>
                      );
                    })
                  ) : (
                    <div className="text-center py-4 bg-white rounded-lg shadow-sm">
                      <h4 className="text-muted mb-0">No follow-ups found</h4>
                    </div>
                  )}
                </div>

                <CardFooter className='py-4'>
                  <nav aria-label='...'>
                    <Pagination
                      className='pagination justify-content-end mb-0'
                      listClassName='justify-content-end mb-0'
                    >
                      <PaginationItem
                        className={listPage > 1 ? '' : 'disabled'}
                      >
                        <PaginationLink
                          onClick={() => this.changePage('prev')}
                          tabIndex='-1'
                        >
                          <i className='fas fa-angle-left' />
                          <span className='sr-only'>Previous</span>
                        </PaginationLink>
                      </PaginationItem>

                      <PaginationItem className='active'>
                        <PaginationLink onClick={(e) => e.preventDefault()}>
                          {listPage}
                        </PaginationLink>
                      </PaginationItem>

                      <PaginationItem
                        className={totalNewPage > listPage ? '' : 'disabled'}
                      >
                        <PaginationLink onClick={() => this.changePage('next')}>
                          <i className='fas fa-angle-right' />
                          <span className='sr-only'>Next</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>

        </Container>

        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={this.state.directWhatsappModal}
          toggle={() => this.setState({ directWhatsappModal: false })}
        >
          <div className='modal-header bg-success text-white d-flex align-items-center justify-content-between p-3' style={{ borderBottom: 'none', borderRadius: '4px 4px 0 0' }}>
            <h4 className="modal-title m-0 text-white font-weight-bold" style={{ fontSize: '1.1rem' }}>
              <i className="fab fa-whatsapp mr-2" style={{ fontSize: '1.3rem' }} /> Direct WhatsApp Message
            </h4>
            <button
              type="button"
              className="close text-white"
              style={{ opacity: '0.8', outline: 'none', border: 'none', background: 'transparent' }}
              onClick={() => this.setState({ directWhatsappModal: false })}
            >
              <span aria-hidden="true" style={{ fontSize: '1.5rem', color: '#fff' }}>&times;</span>
            </button>
          </div>
          <div className='modal-body bg-secondary p-4'>
            <Card className='shadow border-0 bg-white p-4'>
              <Form role='form'>
                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                      <label className="form-control-label font-weight-bold mb-2 text-dark" style={{ fontSize: '0.85rem' }}>Recipient Name</label>
                      <Input
                        type="text"
                        className="form-control-alternative font-weight-bold"
                        style={{ color: '#333', background: '#f5f6f7' }}
                        value={this.state.directWhatsappName}
                        onChange={(e) => this.setState({ directWhatsappName: e.target.value })}
                        placeholder="Recipient Name"
                      />
                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup>
                      <label className="form-control-label font-weight-bold mb-2 text-dark" style={{ fontSize: '0.85rem' }}>Phone Number (with pincode)</label>
                      <div className="d-flex">
                        <Input
                          type="select"
                          className="form-control-alternative mr-2"
                          style={{ width: '120px', fontWeight: '600' }}
                          value={this.state.directWhatsappCountryCode}
                          onChange={(e) => this.setState({ directWhatsappCountryCode: e.target.value })}
                        >
                          <option value="+91">+91 (IN)</option>
                          <option value="+1">+1 (US/CA)</option>
                          <option value="+44">+44 (UK)</option>
                          <option value="+61">+61 (AU)</option>
                          <option value="+65">+65 (SG)</option>
                          <option value="+971">+971 (AE)</option>
                          <option value="+64">+64 (NZ)</option>
                          <option value="+33">+33 (FR)</option>
                          <option value="+49">+49 (DE)</option>
                          <option value="+81">+81 (JP)</option>
                          <option value="+82">+82 (KR)</option>
                          <option value="+60">+60 (MY)</option>
                          <option value="+62">+62 (ID)</option>
                          <option value="+852">+852 (HK)</option>
                        </Input>
                        <Input
                          type="text"
                          className="form-control-alternative font-weight-bold flex-grow-1"
                          value={this.state.directWhatsappNumber}
                          onChange={(e) => this.setState({ directWhatsappNumber: e.target.value })}
                          placeholder="Phone number"
                        />
                      </div>
                    </FormGroup>
                  </div>
                </div>

                <FormGroup className="mt-2">
                  <label className="form-control-label font-weight-bold mb-2 text-dark" style={{ fontSize: '0.85rem' }}>Quick-Select Message Options</label>
                  <div className="d-flex flex-wrap gap-2 mb-3" style={{ gap: '8px' }}>
                    {WHATSAPP_TEMPLATES.map((tpl, idx) => {
                      const isSelected = this.state.directWhatsappTemplateIndex === idx;
                      return (
                        <Button
                          key={idx}
                          type="button"
                          size="sm"
                          color={isSelected ? "success" : "secondary"}
                          className="m-1"
                          style={{
                            borderRadius: '20px',
                            textTransform: 'none',
                            fontWeight: '600',
                            fontSize: '0.78rem',
                            border: isSelected ? '1px solid #28a745' : '1px solid #cad1d7',
                            boxShadow: isSelected ? '0 2px 4px rgba(40, 167, 69, 0.2)' : 'none',
                            transition: 'all 0.2s ease'
                          }}
                          onClick={() => this.handleTemplateChange(idx)}
                        >
                          {tpl.title}
                        </Button>
                      );
                    })}
                  </div>
                </FormGroup>

                <FormGroup>
                  <label className="form-control-label font-weight-bold mb-2 text-dark" style={{ fontSize: '0.85rem' }}>Message Body</label>
                  <textarea
                    className="form-control form-control-alternative"
                    rows={5}
                    placeholder="Type your custom WhatsApp message here..."
                    value={this.state.directWhatsappMessage}
                    onChange={(e) => this.setState({ directWhatsappMessage: e.target.value, directWhatsappTemplateIndex: WHATSAPP_TEMPLATES.length - 1 })}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '1px solid #cad1d7',
                      borderRadius: '6px',
                      fontSize: '0.88rem',
                      lineHeight: '1.5',
                      color: '#2b2b2b'
                    }}
                  />
                </FormGroup>

                <div className="d-flex justify-content-end align-items-center mt-4">
                  <Button
                    color="secondary"
                    type="button"
                    onClick={() => this.setState({ directWhatsappModal: false })}
                    style={{ fontWeight: '600', borderRadius: '4px' }}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="success"
                    type="button"
                    className="ml-2 px-4"
                    onClick={this.sendDirectWhatsapp}
                    disabled={this.state.loading}
                    style={{ fontWeight: '700', borderRadius: '4px', backgroundColor: '#2acb9d', borderColor: '#2acb9d' }}
                  >
                    {this.state.loading ? 'Sending...' : 'Send on WhatsApp'}
                  </Button>
                </div>
              </Form>
            </Card>
          </div>
        </Modal>

        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={notificationCallModal}
          toggle={() =>
            this.toggleModal('notificationCallModal')
          }
        >
          <div className='modal-body p-0'>
            <Card className='bg-secondary shadow border-0'>
              <CardHeader className='bg-transparent pb-5'>
                <div className='text-muted text-center'>
                  <small>{'Send SMS Message'}</small>
                </div>
              </CardHeader>
              <CardBody className='px-lg-5 py-lg-5'>
                <Form role='form'>
                  <FormGroup className={notesError ? 'has-danger' : ''}>
                    <InputGroup className='input-group-alternative'>
                      <textarea
                        placeholder='Enter SMS Message...'
                        cols={100}
                        rows={5}
                        value={twillioMessage}
                        onChange={(e) =>
                          this.setState({ twillioMessage: e.target.value })
                        }
                        style={{ width: '100%', padding: '12px', border: '1px solid #cad1d7', borderRadius: '4px' }}
                      />
                    </InputGroup>
                  </FormGroup>

                  <div className="row text-right">
                    <div className="ml-auto" style={{ marginRight: '10px' }}>
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => this.setState({ notificationCallModal: !notificationCallModal })}
                      >
                        Cancel
                      </Button>
                      <Button
                        disabled={!!loading}
                        color="primary"
                        type="button"
                        onClick={() => this.replyMessageResponse()}
                      >
                        Send Message
                      </Button>
                    </div>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>
        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={salesFollowUpModal}
          toggle={() =>
            this.toggleModal('salesFollowUpModal')
          }
        >
          <div className='modal-body p-0'>
            <Card className='bg-secondary shadow border-0'>
              <CardHeader className='bg-transparent pb-5'>
                <div className='text-muted text-center'>
                  <small>{'Follow Up'}</small>
                </div>
              </CardHeader>
              <CardBody className='px-lg-5 py-lg-5'>
                <Table
                  className='align-items-center table-flush cp;'
                  responsive
                  style={{ marginBottom: '100px' }}
                >
                  <thead className='thead-light'>
                    <tr>
                      <th scope='col'>Date</th>
                      <th scope='col'>Status</th>
                      <th scope='col'>Call By</th>
                      <th scope='col'>Audio</th>
                      <th scope='col'>Link</th>
                      <th scope='col' />
                    </tr>
                  </thead>
                  <tbody>
                    {salesFollowUpInfo &&
                      salesFollowUpInfo.map((value, index) => {
                        return (
                          value.isActive && (
                            <tr key={index} >
                              <td className={'table-column-width'}>
                                <Media className='align-items-center'>
                                  <Media>
                                    <span className='mb-0 text-sm'>
                                      {value.createdAt
                                        ? moment(value.createdAt).format('ll hh:mm A')
                                        : ''}
                                    </span>
                                  </Media>
                                </Media>
                              </td>
                              <td className={'table-column-width'}>{value?.callStatus || ''}</td>
                              <td className={'table-column-width'}>{value?.userType || ''}</td>
                              <td className={'table-column-width'}>
                                {
                                  value.fileName ? (
                                    <AudioPlayer
                                      autoPlay={false}
                                      autoPlayAfterSrcChange={false}
                                      src={value.fileName}
                                      onPlay={e => console.log("onPlay")}
                                    // other props here
                                    />
                                  ) : (
                                    <></>
                                  )
                                }
                              </td>
                              <td className={'table-column-width'}>
                                {
                                  value.fileName ? (
                                    <CopyToClipboard text={value.fileName}>
                                      <i
                                        style={{ cursor: 'pointer' }}
                                        className='BtnFill'
                                        color='success'
                                      ><i className='fa fa-copy'></i>
                                      </i>
                                    </CopyToClipboard>
                                  ) : (
                                    <></>
                                  )
                                }
                              </td>
                            </tr>
                          )
                        );
                      })}
                  </tbody>
                </Table>
                <div className="row text-right">
                  <div className="ml-auto" style={{ marginRight: '10px' }}>
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => this.setState({ salesFollowUpModal: !salesFollowUpModal })}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </Modal>
        <Modal
          className='modal-dialog-centered'
          isOpen={this.state.successModal || this.state.errorModal}
          toggle={() =>
            successModal
              ? this.toggleModal('successModal')
              : errorModal
                ? this.toggleModal('errorModal')
                : null
          }
        >
          <div className='modal-header'>
            <h5 className='modal-title' id='successModalLabel'>
              {modalTitle}
            </h5>
            <button
              aria-label='Close'
              className='close'
              data-dismiss='modal'
              type='button'
              onClick={() =>
                successModal
                  ? this.toggleModal('successModal')
                  : errorModal
                    ? this.toggleModal('errorModal')
                    : null
              }
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          {this.state.successModal ? (
            <div className='modal-body' style={{ color: 'green' }}>
              {message}
            </div>
          ) : this.state.errorModal ? (
            <div className='modal-body' style={{ color: 'red' }}>
              {message}
            </div>
          ) : null}
          <div className='modal-footer'>
            <Button
              color='primary'
              type='button'
              onClick={() =>
                successModal
                  ? this.toggleModal('successModal')
                  : errorModal
                    ? this.toggleModal('errorModal')
                    : null
              }
            >
              Ok
            </Button>
          </div>
        </Modal>


        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={notificationNotesModal}
          toggle={() =>
            this.toggleModal('notificationNotesModal')
          }
        >
          <div className='modal-body p-0'>
            <Card className='bg-secondary shadow border-0'>
              <CardHeader className='bg-transparent pb-5'>
                <div className='text-muted text-center mt-2 mb-3'>
                  <small>{'Notes and Script'}</small>
                </div>
              </CardHeader>
              <CardBody className='px-lg-5 py-lg-5'>
                <Form role='form'>
                  <FormGroup className={notesError ? 'has-danger' : ''}>
                    <label>Followup Notes</label>
                    <InputGroup className='input-group-alternative'>
                      <textarea
                        placeholder='Followup notes'
                        cols={100}
                        rows={5}
                        value={salesFollowUpNotes}
                        onChange={(e) =>
                          this.setState({ salesFollowUpNotes: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className={notesError ? 'has-danger' : ''}>
                    <label>Notes</label>
                    <InputGroup className='input-group-alternative'>
                      <textarea
                        disabled={true}
                        placeholder='Teacher notes'
                        cols={100}
                        rows={5}
                        value={followUpNotes}
                        onChange={(e) =>
                          this.setState({ followUpNotes: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className={notesError ? 'has-danger' : ''}>
                    <label>Class Script</label>
                    <InputGroup className='input-group-alternative'>
                      <textarea
                        disabled={true}
                        placeholder='Followup Script'
                        cols={100}
                        rows={5}
                        value={followUpScript}
                        onChange={(e) =>
                          this.setState({ followUpScript: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <div className='text-center'>
                    {uploading ? (
                      <span style={{ color: 'red' }}>Wait...</span>
                    ) : null}

                    <Button
                      disabled={uploading || loading ? true : false}
                      className='my-4'
                      color='primary'
                      type='button'

                      onClick={() => {
                        this.updateNotificationNotes();
                      }}
                    >
                      {'Save'}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>

        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={salesFollowUpClassScriptModal}
          toggle={() =>
            this.toggleModal('salesFollowUpClassScriptModal')
          }
        >
          <div className='modal-body p-0'>
            <Card className='bg-secondary shadow border-0'>
              <CardHeader className='bg-transparent pb-5'>
                <div className='text-muted text-center mt-2 mb-3'>
                  <small>{'Update Script'}</small>
                </div>
              </CardHeader>
              <CardBody className='px-lg-5 py-lg-5'>
                <Form role='form'>
                  <FormGroup className={classIdError ? 'has-danger' : ''}>
                    <InputGroup className="input-group-alternative" styles={{ width: '100%' }}>
                      <div style={{ width: "100%", minWidth: "200px" }}>
                        <Select
                          style={{ width: "100%", minWidth: "200px" }}
                          options={[
                            ...(classList &&
                              classList.map((item) => ({
                                value: item.classId,
                                label: item.name,
                              }))),
                          ]}
                          value={
                            classId && {
                              value: classId,
                              label: classList.find((item) => item.classId === classId).name,
                            }
                          }
                          placeholder="All Classes"
                          onChange={(e) => {
                            this.changeClassMessage(e.value);
                            this.setState({ classId: e.value })
                          }}
                          isSearchable={true}
                        />
                      </div>
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className={notesError ? 'has-danger' : ''}>
                    <label>Script</label>
                    <InputGroup className='input-group-alternative'>
                      <textarea
                        placeholder='Enter Followup Script'
                        cols={100}
                        rows={5}
                        value={followUpScript}
                        onChange={(e) =>
                          this.setState({ followUpScript: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <div className='text-center'>
                    {uploading ? (
                      <span style={{ color: 'red' }}>Wait...</span>
                    ) : null}

                    <Button
                      disabled={uploading || loading ? true : false}
                      className='my-4'
                      color='primary'
                      type='button'
                      onClick={() => {
                        this.updateNotificatioScript();
                      }}
                    >
                      {'Save'}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>

        <Modal
          className='modal-dialog-centered'
          size='lg'
          isOpen={editModal}
          toggle={() =>
            this.toggleModal('editModal')
          }
        >
          <div className='modal-body p-0'>
            <Card className='bg-secondary shadow border-0'>
              <CardHeader className='bg-transparent pb-5'>
                <div className='text-muted text-center mt-2 mb-3'>
                  <small>{'Edit Notification'}</small>
                </div>
              </CardHeader>
              <CardBody className='px-lg-5 py-lg-5'>
                <Form role='form'>
                  <FormGroup className={nameError ? 'has-danger' : ''}>
                    <label>Name</label>
                    <InputGroup className='input-group-alternative'>
                      <Input
                        disabled
                        placeholder='Name'
                        type='text'
                        name='name'
                        value={name}
                        onChange={(e) =>
                          this.setState({ name: e.target.value })
                        }
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className={mobileError || (mobile && mobile[0] === '1') ? 'has-danger' : ''}>
                    <label>Mobile Number (No Dashes Or Spaces OR Country Code. US number only)</label>
                    <InputGroup className='input-group-alternative'>
                      <Input
                        placeholder='Mobile Number'
                        ype='text'
                        name='mobile'
                        value={mobile}
                        onChange={(e) => {
                          const input = e.target.value.replace(/\D/g, '').slice(0, 15); // remove non-digits and
                          // limit to 10 digits
                          this.setState({ mobile: input });
                        }}
                      />
                    </InputGroup>
                    {mobileError && <div className="text-danger">Please enter a valid mobile number.</div>}
                    {mobile && mobile[0] === '1' && <div className="text-danger">Please enter a valid US mobile number (without country code).</div>}
                  </FormGroup>

                  <div className='text-center'>
                    {uploading ? (
                      <span style={{ color: 'red' }}>Wait...</span>
                    ) : null}

                    <Button
                      disabled={uploading || loading ? true : false}
                      className='my-4'
                      color='primary'
                      type='button'
                      onClick={() => {
                        this.addOrUpdateNotification(true);
                      }}
                    >
                      {'Update'}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>

      </>
    );
  }
}

export default SalesFollowUp;
